import { useAccordionButton } from "react-bootstrap";

export const AccordionToogle = (props : { children : any, eventKey : string }) => {
  const decoratedOnClick = useAccordionButton(props.eventKey, () => {} );

  return (
    <span onClick={decoratedOnClick}>
      {props.children}
    </span>
  );
}
